<template>
  <div class="product-cell">
    <div
      class="product"
      @click="getProductDetails(product.ProductNumber, product.ShopId)"
    >
      <van-image class="photo" :src="productImg">
        <template v-slot:error>
          <img class="ImgIcon" src="~assets/img/other/empty.gif" />
        </template>
      </van-image>

      <div class="content">
        <div class="content-title">
          <div class="discount" v-if="product.IsCouponProduct">
            {{ $t.shopping.isCoupon }}
          </div>
          <div class="brand" v-if="product.IsBrandProduct">{{ $t.shopping.isBrand }}</div>
          <div class="attestation" v-if="product.IsAttestationProduct">
            {{ $t.shopping.isAttestation }}
          </div>
          <span class="name">{{ product.ProductName }}</span>
        </div>
        <p class="detail">
          {{ product.ProductModelStr | productModelStrFilter }}
        </p>
        <div class="price-count">
          <p class="price">
            $
            <span>{{ product.NowMoney | formatPrice }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Image, Radio, RadioGroup } from "vant";

Vue.use(Image).use(Radio).use(RadioGroup);
export default {
  name: "ProductCell",
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    productImg() {
      return this.$api.formatVancheenUrl(this.product.ProductPhoto.split("|")[0]);
    },
  },
  filters: {
    formatPrice(val) {
      var str = val.toFixed(2) + "";
      var intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ","); // 取到整数部分
      var dot = str.substring(str.length, str.indexOf(".")); // 取到小数部分搜索
      var ret = intSum + dot;
      return ret;
    },
    // 规则过滤器
    productModelStrFilter(value) {
      return value.replace(/\|/, " ");
    },
  },
  methods: {
    getProductDetails(ProductNumber, ShopId) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "details",
        name: "details",
        query: [
          {
            name: "ProductNumber",
            value: ProductNumber,
          },
          {
            name: "ShopId",
            value: ShopId,
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~assets/scss/publicStyle";
@import "~assets/scss/var";

.product-cell {
  display: flex;
  padding: 19px 0 18px;
  align-items: flex-start;

  ::v-deep .checkbox {
    flex-shrink: 0;
    margin-top: 18px;
  }

  .product {
    flex-grow: 1;
    display: flex;
    overflow: hidden;
    word-break: break-word;
    .photo {
      width: 56px;
      height: 56px;
      object-fit: cover;
      margin-top: 7px;
      .ImgIcon {
        height: 56px;
        width: 56px;
        object-fit: cover;
      }
      ::v-deep .van-image__img {
        height: 56px;
        width: 56px;
        object-fit: cover;
      }
      ::v-deep .van-image__error {
        height: 56px;
        width: 56px;
        object-fit: cover;
      }
    }

    .content {
      width: 70%;
      margin-left: 5%;

      p {
        margin: 0;
        padding: 0;
      }

      .content-title {
        .discount {
          vertical-align: middle;
          display: inline-block;
          background: red;
          color: white;
          padding: 0px 2px;
          border-radius: 2px;
          font-size: 10px;
          margin-right: 5px;
        }
        .brand {
          vertical-align: middle;
          display: inline-block;
          background: #e6a23c;
          color: white;
          padding: 0px 2px;
          border-radius: 2px;
          font-size: 10px;
          margin-right: 5px;
        }
        .attestation {
          vertical-align: middle;
          display: inline-block;
          background: #22b196;
          color: white;
          padding: 0px 2px;
          border-radius: 2px;
          font-size: 10px;
          margin-right: 5px;
        }
        .name {
          vertical-align: middle;
          display: inline-block;
          font-size: 14px;
          color: black;
        }
      }

      .detail {
        color: $-color-light-gray;
        font-size: 13px;
        margin-top: 10px;
      }

      .notice {
        color: $-color-red;
        font-size: 13px;
        font-weight: bold;
        margin-top: 10px;
      }

      .price-count {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;

        .price {
          font-size: 12px;
          color: $-color-red;
          font-weight: bold;

          span {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
